/* eslint-disable camelcase */

import { string } from 'yup/lib/locale';
import baseApi from './base';
import { Organization } from './event';
import { TicketCategory } from './ticket-category';

export interface Subscription {
  id: number;
  uuid: string;
  name: string;
  cover: string | null;
  description: string;
  startDate: Date;
  endDate: Date;
  status: string;
  isAvailable: boolean;
  capacity: number;
  remaining: number;
  categoryId: number | null;
  chartKey: string | null;
  web3Address: string | null;
  web3Id: number | null;
  web3txHash: string | null;
  chain: 'POLYGON' | 'CHILIZ';
  provenanceHash: string | null;
  deployerAddress: string | null;
  factoryAddress: string | null;
  organizationId: number;
  generalAdmission: boolean;

  // TODO missing fields
  isAvailible: boolean;
  minPrice: number;
  maxPrice: number;

  tarifs: TicketCategory[];
  organization: Organization;
  customers: UserSubscription[];
}

export interface SubscriptionFromApi {
  id: number;
  uuid: string;
  name: string;
  cover: string | null;
  description: string;
  startDate: Date;
  endDate: Date;
  status: string;
  isAvailable: boolean;
  capacity: number;
  remaining: number;
  categoryId: number | null;
  chartKey: string | null;
  web3Address: string | null;
  web3Id: number | null;
  web3txHash: string | null;
  chain: 'POLYGON' | 'CHILIZ';
  provenanceHash: string | null;
  deployerAddress: string | null;
  factoryAddress: string | null;
  organizationId: number;
  generalAdmission: boolean;

  tarifs: Tarif[];
  organization: Organization;
  customers: UserSubscription[];
}

export interface UserSubscription {
  id: number;
  uuid: string;
  userId: number;
  firstName: string;
  lastName: string;
  subscriptionId: number;
  tarifId: number;
  startDate: Date;
  endDate: Date;
  seatLabel: string | null;
  seatCategoryLabel: string | null;
  seatSection: string | null;
  qrCode: string | null;
  nftId: number;
  txHash: string;
  tokenUri: string;
  isScanned: boolean;
  tarif: Tarif;
  subscription: Subscription;
}

export interface Tarif {
  id: number;

  isAvailable: boolean;

  uuid: string;
  name: string;
  amount: number;
  description: string | null;
  subscriptionUuid: string | null;
}

export interface claimSubscriptionForm {
  subscriptionInvite: string;
}

const subscriptionApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getAllSubscriptions: builder.query<Subscription[], void>({
      query: () => ({
        url: `/subscriptions`,
        method: 'GET'
      }),
      providesTags: ['subscriptions']
    }),
    getOrganizationSubscriptions: builder.query<Subscription[], string>({
      query: orgaUuid => ({
        url: `/subscriptions/${orgaUuid}`,
        method: 'GET'
      }),
      providesTags: ['subscriptions']
    }),
    getSubscriptionDetails: builder.query<Subscription, string>({
      query: subscriptionUuid => ({
        method: 'GET',
        url: `/subscriptions/${subscriptionUuid}`
      }),
      transformResponse: (response: SubscriptionFromApi) => {
        return {
          ...response,
          isAvailible: true,
          minPrice: response.tarifs.reduce((acc, tarif) => Math.min(acc, tarif.amount), 999999),
          maxPrice: response.tarifs.reduce((acc, tarif) => Math.max(acc, tarif.amount), 0),
          subTicketCategory: [],
          tarifs: response.tarifs.map(tarif => ({
            ...tarif,
            subTicketCategory: [],
            price: tarif.amount,
            amount: tarif.amount,
            maxPerPerson: 1,
            minPerPerson: 1,
            quantitySold: 0,
            startSaleDate: null,
            endSaleDate: null,
            range: null,
            status: 'ACTIVE',
            isAvailable: true,
            updatedAt: new Date(),
            createdAt: new Date(),
            deletedAt: null,
            ticketCategoryId: null,
            eventId: response.id,
            organizationId: response.organizationId,
            quantityAvailable: 9999,
            description: tarif.description || ''
          }))
        };
      }
    }),
    getUserSubscriptions: builder.query<UserSubscription[], void>({
      query: () => ({
        method: 'GET',
        url: `/subscriptions/user-subscriptions`
      }),
      providesTags: ['user-subscriptions']
    }),
    getUserSubscriptionDetails: builder.query<UserSubscription, string>({
      query: uuid => ({
        method: 'GET',
        url: `/subscriptions/user-subscription/${uuid}`
      }),
      providesTags: ['user-subscriptions']
    }),
    subscriptionByInvite: builder.query<Subscription & { quantity: number }, string>({
      query: inviteUuid => ({
        method: 'GET',
        url: `/subscriptions/subscription-invite/${inviteUuid}`
      })
    }),
    claimSubscription: builder.mutation<void, claimSubscriptionForm>({
      query: body => ({
        method: 'PATCH',
        url: `/subscriptions/claim-invite`,
        body
      })
    })
  })
});

export default subscriptionApi;
